import { render, staticRenderFns } from "./licen-dialog.vue?vue&type=template&id=38a17e70&scoped=true&"
import script from "./licen-dialog.vue?vue&type=script&lang=js&"
export * from "./licen-dialog.vue?vue&type=script&lang=js&"
import style0 from "./licen-dialog.vue?vue&type=style&index=0&id=38a17e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a17e70",
  null
  
)

export default component.exports